<template>
  <div class="warpper">
    <header></header>
    <div class="content">
      <div class="title">
        <div></div>
        <div>方案信息</div>
      </div>
      <div class="cell-group">
        <span>
          <span>*</span>
          公司名称：
        </span>
        <el-input
          v-model="name"
          placeholder="请输入客户的商号或公司全称（城市+商号+行业+组织形式）"
        ></el-input>
      </div>
      <div class="cell-group">
        <span>
          <span>*</span>
          注册地区：
        </span>
        <div class="region">
          <el-select
            v-model="region"
            placeholder="请选择"
            @change="changeCityValue"
          >
            <el-option
              v-for="(item, index) in options"
              :key="index"
              @click.native="getAreaIndex(index)"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            v-model="value"
            placeholder="请选择"
            @change="changeAreaValue"
          >
            <el-option
              v-for="item in cities"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="cell-group">
        <span>
          <span>*</span>
          纳税人类型：
        </span>
        <div class="select">
          <el-select
            v-model="taxpayerValue"
            placeholder="请选择地区后再选择当前项"
            @change="changeTaxValue"
          >
            <el-option
              v-for="item in taxpayer"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="cell-group">
        <span>
          <span></span>
          公司性质：
        </span>
        <div class="select">
          <el-select
            v-model="natureValue"
            placeholder="请选择"
            @change="changeNatureValue"
          >
            <el-option
              v-for="item in nature"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="cell-group">
        <span>
          <span>*</span>
          组织类型：
        </span>
        <div class="select">
          <!-- 有限公司 -->
          <el-select v-model="tissueValue" placeholder="请选择">
            <el-option
              v-for="item in tissue"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="cell-group">
        <span>
          <span>*</span>
          从事行业：
        </span>
        <div class="industry">
          <el-radio-group v-model="industryValue">
            <el-radio-button
              :label="item"
              v-for="(item, index) in industry"
              :key="index"
            ></el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="cell-group">
        <span>
          <span>*</span>
          经营范围：
        </span>
        <el-input
          type="textarea"
          :rows="3"
          placeholder="请自定义输入公司经营范围，每个经营项以“ ；”隔开"
          v-model="scope"
        ></el-input>
      </div>
      <div class="cell-group">
        <span>
          <!-- <span>*</span> -->
          方案备注：
        </span>
        <el-input v-model="notes" placeholder="请输入该方案其他备注"></el-input>
      </div>
      <div class="cell-group submitwrap">
        <el-button @click="submitAdd">提交</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import req from "axios";
export default {
  props: ["passParams", "passHeader"],
  data() {
    return {
      needNo: "", // 接口中需要使用的needNo
      headers: "", // 接口之中需要使用的Headers
      passCompanyDialog: false, // 传递到父组件，关闭对话框
      name: "",
      cities: [], // 省对应的城市区域集合 实现联动
      options: [
        {
          label: "北京市",
          value: "北京市",
          children: [
            {
              value: "朝阳区",
              label: "朝阳区",
            },
            {
              value: "海淀区",
              label: "海淀区",
            },
            {
              value: "顺义区",
              label: "顺义区",
            },
            {
              value: "东城区",
              label: "东城区",
            },
            {
              value: "西城区",
              label: "西城区",
            },
            {
              value: "丰台区",
              label: "丰台区",
            },
            {
              value: "石景山区",
              label: "石景山区",
            },
          ],
        },
        {
          value: "上海市",
          label: "上海市",
          children: [
            {
              value: "杨浦区",
              label: "杨浦区",
            },
            {
              value: "嘉定区",
              label: "嘉定区",
            },
            {
              value: "崇明区",
              label: "崇明区",
            },
          ],
        },
        {
          label: "杭州市",
          value: "杭州市",
          children: [
            {
              value: "西湖区",
              label: "西湖区",
            },
            {
              value: "江干区",
              label: "江干区",
            },
            {
              value: "余杭区",
              label: "余杭区",
            },
            {
              value: "上城区",
              label: "上城区",
            },
            {
              value: "拱墅区",
              label: "拱墅区",
            },
            {
              value: "滨江区",
              label: "滨江区",
            },
            {
              value: "下城区",
              label: "下城区",
            },
            {
              value: "萧山区",
              label: "萧山区",
            },
          ],
        },
        {
          value: "深圳市",
          label: "深圳市",
          children: [
            {
              value: "南山区",
              label: "南山区",
            },
            {
              value: "福田区",
              label: "福田区",
            },
            {
              value: "罗湖区",
              label: "罗湖区",
            },
            {
              value: "龙岗区",
              label: "龙岗区",
            },
            {
              value: "前海自贸区",
              label: "前海自贸区",
            },
          ],
        },
        {
          label: "成都市",
          value: "成都市",
          children: [
            {
              value: "锦江区",
              label: "锦江区",
            },
            {
              value: "高新区",
              label: "高新区",
            },
            {
              value: "武侯区",
              label: "武侯区",
            },
            {
              value: "金牛区",
              label: "金牛区",
            },
            {
              value: "青羊区",
              label: "青羊区",
            },
            {
              value: "天府新区",
              label: "天府新区",
            },
          ],
        },
        {
          label: "广州市",
          value: "广州市",
          children: [
            {
              value: "天河区",
              label: "天河区",
            },
            {
              value: "越秀区",
              label: "越秀区",
            },
          ],
        },
      ],
      region: "",
      taxpayerValue: "",
      natureValue: "",
      value: "",
      industryValue: "文化传媒类",
      tissueValue: "",
      notes: "",
      scope: "",
      currentTaxpayer: [
        {
          value: "内资小规模",
          label: "内资小规模",
        },
        {
          value: "内资一般人",
          label: "内资一般人",
        },
        {
          value: "外资小规模",
          label: "外资小规模",
        },
        {
          value: "外资一般人",
          label: "外资一般人",
        },
        {
          value: "合资小规模",
          label: "合资小规模",
        },
        {
          value: "合资一般人",
          label: "合资一般人",
        },
      ],
      taxpayer: [], // 当前城区条件下的纳税人类型 slice去截取
      nature: [
        // // 公司性质由必选改为非必选，新添加的 请选择项 一项，清空选择的数据
        //
        // {
        //   value: "股份",
        //   label: "股份"
        // },
        // {
        //   value: "集团",
        //   label: "集团"
        // }
      ],
      natureOneSh: [
        // 公司性质由必选改为非必选，新添加的 请选择项 一项，清空选择的数据
        {
          value: "请选择",
          label: "请选择",
        },
        // {
        //   value: "默认",
        //   label: "默认",
        // },
        {
          value: "股份",
          label: "股份",
        },
        {
          value: "集团",
          label: "集团",
        },
      ], // 上海的公司分类
      natureTwoSzHz: [
        // 公司性质由必选改为非必选，新添加的 请选择项 一项，清空选择的数据
        {
          value: "请选择",
          label: "请选择",
        },
        // {
        //   value: "默认",
        //   label: "默认",
        // },
        {
          value: "股份",
          label: "股份",
        },
      ], // 深圳和杭州的公司分类
      tissue: [
        {
          value: "有限公司",
          label: "有限公司",
        },
      ],
      tissueShCmq: [
        {
          value: "有限公司",
          label: "有限公司",
        },
        {
          label: "个人独资",
          value: "个人独资",
        },
        {
          label: "合伙企业",
          value: "合伙企业",
        },
      ],
      industries: [
        "文化传媒类",
        "科技类",
        "咨询类",
        "影业类",
        "贸易类",
        "广告类",
        "管理类",
        "租赁类",
        "代理类",
        "培训类",
        "设计类",
        "服务类",
        "工程类",
      ], // 所有的13个行业类型
      industry: [
        "文化传媒类",
        "科技类",
        "咨询类",
        "影业类",
        "贸易类",
        "广告类",
        "管理类",
        "租赁类",
        "代理类",
        "培训类",
        "设计类",
        "服务类",
        "工程类",
      ], // 提交的 行业类型 默认 13 个 北京海淀区时是3个
    };
  },
  methods: {
    getAreaIndex(index) {
      this.value = ""; // 点击 省级 城市区域的value清空
      this.cities = this.options[index].children;
    }, // 获取地区索引
    changeCityValue(currentCityValue) {
      // console.log(currentCityValue, 1111111, this.region);
      // 清空之前选择的 纳税人类型、公司性质、组织类型
      this.taxpayerValue = "";
      this.taxpayer = [];
      this.natureValue = "";
      this.nature = [];
      this.tissueValue = "";
      this.tissue = [];
      // 默认行业为所有的
      this.industry = [
        "文化传媒类",
        "科技类",
        "咨询类",
        "影业类",
        "贸易类",
        "广告类",
        "管理类",
        "租赁类",
        "代理类",
        "培训类",
        "设计类",
        "服务类",
        "工程类",
      ];

      // 公司性质
      // 北京市 广州市 成都市
      if (
        currentCityValue == "北京市" ||
        currentCityValue == "广州市" ||
        currentCityValue == "成都市"
      ) {
        this.nature = [
          // 公司性质由必选改为非必选，新添加的 请选择项 一项，清空选择的数据
          {
            value: "请选择",
            label: "请选择",
          },
          {
            value: "股份",
            label: "股份",
          },
          {
            value: "集团",
            label: "集团",
          },
        ];
      }
    }, // 城市 下拉框的值 变化时
    changeAreaValue(currentAreaValue) {
      // console.log(currentAreaValue, 222222, this.value);
      // 清空之前选择的 纳税人类型、公司性质、组织类型
      this.taxpayerValue = "";
      this.natureValue = "";
      this.tissueValue = "";
      // 特殊的，北京海淀区的行业类型只有三个
      if (currentAreaValue == "海淀区") {
        this.industry = this.industries.slice(0, 3);
      } else {
        this.industry = this.industries;
      }
      // 特殊的，上海崇明区的组织类型有三种
      if (currentAreaValue == "崇明区") {
        this.tissue = this.tissueShCmq;
      } else {
        this.tissue = [
          {
            value: "有限公司",
            label: "有限公司",
          },
        ];
      }
      // 以下的是 纳税人类型
      // 北京的
      if (
        currentAreaValue == "朝阳区" ||
        currentAreaValue == "顺义区" ||
        currentAreaValue == "海淀区"
      ) {
        this.taxpayer = this.currentTaxpayer;
      }
      if (
        currentAreaValue == "东城区" ||
        currentAreaValue == "西城区" ||
        currentAreaValue == "丰台区" ||
        currentAreaValue == "石景山区"
      ) {
        this.taxpayer = this.currentTaxpayer.slice(0, 2);
      }
      // 成都的
      if (currentAreaValue == "锦江区" || currentAreaValue == "高新区") {
        this.taxpayer = this.currentTaxpayer;
      }
      if (
        currentAreaValue == "武侯区" ||
        currentAreaValue == "金牛区" ||
        currentAreaValue == "青羊区" ||
        currentAreaValue == "天府新区"
      ) {
        this.taxpayer = this.currentTaxpayer.slice(0, 2);
      }
      // 上海的
      if (
        currentAreaValue == "杨浦区" ||
        currentAreaValue == "嘉定区" ||
        currentAreaValue == "崇明区"
      ) {
        this.taxpayer = this.currentTaxpayer.slice(0, 2);
      }
      // 杭州的
      if (
        currentAreaValue == "西湖区" ||
        currentAreaValue == "江干区" ||
        currentAreaValue == "余杭区" ||
        currentAreaValue == "上城区" ||
        currentAreaValue == "拱墅区" ||
        currentAreaValue == "滨江区" ||
        currentAreaValue == "下城区" ||
        currentAreaValue == "萧山区"
      ) {
        this.taxpayer = this.currentTaxpayer.slice(0, 2);
      }
      // 深圳的
      if (
        currentAreaValue == "南山区" ||
        currentAreaValue == "福田区" ||
        currentAreaValue == "罗湖区" ||
        currentAreaValue == "龙岗区" ||
        currentAreaValue == "前海自贸区"
      ) {
        this.taxpayer = this.currentTaxpayer.slice(0, 4);
      }
      // 广州的
      if (currentAreaValue == "天河区" || currentAreaValue == "越秀区") {
        this.taxpayer = this.currentTaxpayer;
      }

      // 以下是关于公司性质的
      // 上海的
      if (currentAreaValue == "崇明区") {
        this.nature = [
          // 公司性质由必选改为非必选，新添加的 请选择项 一项，清空选择的数据
          {
            value: "请选择",
            label: "请选择",
          },
          // {
          //   value: "默认",
          //   label: "默认",
          // },
        ];
      }
      if (currentAreaValue == "杨浦区" || currentAreaValue == "嘉定区") {
        this.nature = this.natureOneSh;
      }
      // 杭州的
      if (
        currentAreaValue == "西湖区" ||
        currentAreaValue == "江干区" ||
        currentAreaValue == "余杭区" ||
        currentAreaValue == "上城区" ||
        currentAreaValue == "拱墅区" ||
        currentAreaValue == "滨江区" ||
        currentAreaValue == "下城区" ||
        currentAreaValue == "萧山区"
      ) {
        this.nature = this.natureTwoSzHz;
      }
    }, // 区域 下拉框的值 变化时
    changeTaxValue(currentTaxValue) {
      // console.log(this.region, this.value, currentTaxValue);
      if (this.region == "深圳市") {
        if (
          currentTaxValue == "内资小规模" ||
          currentTaxValue == "内资一般人"
        ) {
          this.nature = this.natureTwoSzHz;
        }
        if (
          currentTaxValue == "外资小规模" ||
          currentTaxValue == "外资一般人"
        ) {
          this.nature = [
            // 公司性质由必选改为非必选，新添加的 请选择项 一项，清空选择的数据
            {
              value: "请选择",
              label: "请选择",
            },
            // {
            //   value: "默认",
            //   label: "默认",
            // },
          ];
        }
      }
    }, // 纳税人 下拉值变化时 为深圳的公司性质选择作准备
    // 公司性质由必选改为非必选，新添加的 请选择项 一项，清空选择的数据
    changeNatureValue(currentNatureValue) {
      // console.log(currentNatureValue, this.nature, this.natureValue);
      if (currentNatureValue == "请选择") {
        this.natureValue = ""; // 清除了选项值，也是 提交数据值为空
      }
      // 特殊的，，，
      // 上海崇明区
      if (this.region == "上海市" && this.value == "崇明区") {
        this.natureValue = "请选择";
      }
      // 深圳的 外资小规模、外资一般人
      if (this.region == "深圳市" && this.taxpayerValue == "外资小规模") {
        this.natureValue = "请选择";
      }
      if (this.region == "深圳市" && this.taxpayerValue == "外资一般人") {
        this.natureValue = "请选择";
      }
      console.log(this.region, this.value, this.taxpayerValue);
    }, // 公司性质 下拉值变化时 当当前值为 请选择时，清空数据
    submitAdd() {
      // 非空判断
      if (this.name == "") {
        this.$message("公司注册名称不能为空");
        return;
      }
      if (this.region == "") {
        this.$message("公司注册地区省份不能为空");
        return;
      }
      if (this.value == "") {
        this.$message("公司注册地区市区不能为空");
        return;
      }
      if (this.taxpayerValue == "") {
        this.$message("公司注册纳税人类型不能为空");
        return;
      }
      // if (this.natureValue == "") {
      //   this.$message("公司注册公司性质不能为空");
      //   return;
      // } // 公司性质 股份和 集团  在提交给后端后，可以为空

      // 公司注册组织类型 一个：有限公司 时，注释掉下面的 if
      if (this.tissueValue == "") {
        this.$message("公司注册组织类型不能为空");
        return;
      }

      if (this.industryValue == "") {
        this.$message("公司注册从事行业不能为空");
        return;
      }
      if (this.scope == "") {
        this.$message("公司注册经营范围不能为空");
        return;
      }

      // console.log(
      //   "按提交按钮的提交前的参数：",
      //   "公司名称：",
      //   this.name,
      //   "注册地区-省：",
      //   this.region,
      //   "注册地区-市：",
      //   this.value,
      //   "纳税人类型：",
      //   this.taxpayerValue,
      //   "公司性质：",
      //   this.natureValue,
      //   111111 + "如果是 默认 记得提交时替换为空",
      //   this.natureValue == "默认",
      //   "组织类型：",
      //   this.tissueValue,
      //   "从事行业：",
      //   this.industryValue,
      //   "经营范围：",
      //   this.scope,
      //   "方案备注：",
      //   this.notes
      // );

      req
        .post(
          "/web/action/icapi/springBoard",
          {
            actionType: "submitProgramme",
            actionBody: {
              needNo: this.needNo,
              solutionContent: {
                bizType: "gszc", // 注册类型：
                solution: {
                  // 公司注册方案
                  companyName: this.name, //公司名称
                  city: this.region, // 注册地区：省
                  area: this.value, // 注册地区：市
                  companyCategory: this.taxpayerValue, // 纳税人类型
                  companyType:
                    // this.natureValue == "默认" ? "" : this.natureValue, // 公司性质
                    // 公司性质由必选改为非必选，新添加的 请选择项 一项，清空选择的数据 && 同时去掉默认的选项
                    this.natureValue == "请选择" ? "" : this.natureValue, // 公司性质
                  orgType: this.tissueValue, // 组织类型
                  // orgType: "有限公司", // 组织类型  // 公司注册组织类型 一个：有限公司 时
                  industryType: this.industryValue, // 从事行业
                  scope: this.scope, //  经营范围
                  remark: this.notes, // 方案备注
                },
              },
            },
          },
          this.headers
        )
        .then((res) => {
          if (res.data.status == 0) {
            this.$message("公司注册方案提交成功");
            // 清空 字段
            this.name = "";
            this.region = "";
            this.value = "";
            this.taxpayerValue = "";
            this.natureValue = "";
            this.tissueValue = "";
            this.industryValue = "";
            this.scope = "";
            this.notes = "";
            this.$emit("companyAddDone", this.passCompanyDialog);
          } else {
            this.$message("公司注册方案提交失败");
          }
        });
    },
  },
  created() {
    this.needNo = this.passParams.needNo;
    this.headers = this.passHeader;
  },
};
</script>
<style lang="scss">
.warpper {
  header {
    /* height: 43px; */
    /* padding: 0 20px; */
    border-bottom: 1px solid #e8e8e8;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    display: flex;
    align-items: center;
    justify-content: space-between;
    > i {
      cursor: pointer;
    }
  }
  .content {
    box-sizing: border-box;
    .title {
      display: flex;
      height: 38px;
      align-items: flex-end;
      font-size: 14px;
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      box-sizing: border-box;
      /* padding-left: 70px; */
      padding-left: 50px;
      > div:nth-child(1) {
        width: 2px;
        margin-right: 6px;
        height: 12px;
        background: rgba(223, 183, 106, 1);
      }
    }
    .cell-group {
      margin-top: 20px;
      box-sizing: border-box;
      /* padding-left: 55px; */
      padding-left: 75px;
      > span {
        display: inline-block;
        width: 94px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        text-align: right;
        > span {
          color: #dfb76a;
          font-size: 12px;
        }
      }
      .el-input {
        width: 430px;
        .el-input__inner {
          height: 34px;
          line-height: 0;
        }
      }
      .el-textarea {
        width: 430px;
        display: inline-block;
        .el-textarea__inner {
          resize: none;
        }
      }
      > .region {
        display: inline-block;
        .el-select {
          .el-input--suffix {
            width: 210px;
          }
          .el-input--suffix:nth-child(1) {
            margin-right: 10px;
          }
        }
      }
      > .select {
        display: inline-block;
        .el-select {
          .el-input--suffix {
            width: 430px;
          }
        }
      }
      > .industry {
        display: inline-block;
        /* width: 430px; */
        width: 600px;
        .el-radio-button__inner {
          padding: 0;
          line-height: 34px;
          text-align: center;
          width: 100px;
          height: 34px;
          background: rgba(255, 255, 255, 1);
          border-radius: 3px;
          border: 1px solid rgb(7, 10, 14);
          margin-right: 10px;
          margin-top: 10px;
        }
        .el-radio-button {
          position: relative;
        }
        // 小图标
        .el-radio-button__orig-radio:checked + .el-radio-button__inner::after {
          content: "";
          background: url("../../assets/imgs/fqembed/right.png") no-repeat;
          background-size: 103% 103%;
          width: 21.6px;
          height: 22.6px;
          position: absolute;
          right: -1px;
          bottom: 0;
        }
        .el-radio-button__orig-radio:checked + .el-radio-button__inner {
          color: #333333;
          border-color: #dfb76a;
          box-shadow: none;
        }

        .el-radio-button__inner:hover {
          color: #333;
        }
        .el-radio-button:nth-child(5n) {
          .el-radio-button__inner {
            margin-right: 0;
          }
        }
      }
      > .el-button {
        width: 106px;
        height: 30px;
        background: rgba(223, 183, 106, 1);
        border-radius: 3px;
        padding: 0;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        margin-left: 94px;
      }
    }
    .cell-group:nth-child(7),
    .cell-group:nth-child(8) {
      display: flex;
      > span {
        margin-top: 15px;
      }
    }
    .cell-group:nth-of-type(10) {
      margin-top: 25px;
    }
    .submitwrap {
      padding-left: 30%;
    }
  }
}
</style>
